import { transformMaskedQueryToCql } from '@app/components';
import { escapeUnescapedQuotesAndBackslashes } from '@app/utils';

import { allRecordsCql, SearchOption, searchOptionMap } from '../../constants';

export const forbiddenCharactersRules = [
  { characters: ['=', ';', ',', '%', '@', '#', '!'], replacement: '' },
  { characters: ['`'], replacement: "'" },
];

export const sanitizeQuery = (query: string) => {
  let escapedQuery = escapeUnescapedQuotesAndBackslashes(query);

  forbiddenCharactersRules.forEach(rule => {
    const { characters, replacement } = rule;

    escapedQuery = escapedQuery.replace(
      new RegExp(`[${characters.join('\\')}]`, 'g'),
      replacement
    );
  });

  return escapedQuery.trim();
};

export const getQueryCQL = (query: string, option: string): string => {
  const sanitizedQuery = sanitizeQuery(query);

  if (
    searchOptionMap[option] === searchOptionMap[SearchOption.keyword] &&
    (!query || query === '*')
  ) {
    return allRecordsCql;
  }

  if (query && option === SearchOption.advanced) {
    return transformMaskedQueryToCql(query);
  }

  if (query && option === SearchOption.query) {
    return query;
  }

  return query && `${searchOptionMap[option]} "${sanitizedQuery}"`;
};
